module.exports = __webpack_public_path__ + "img/flow3.dde47a07.png";